import { pick, map } from 'lodash-es';
import { appStore } from '../helpers';

const entitiesFilter = (entities, valuesToMatch, key) =>
  entities.filter((entity) => valuesToMatch.includes(entity[key]));

export const watchlistSerializedParams = (entities, watchlistParams = {}) => {
  const watchlistApps = entitiesFilter(entities, ['app', 'unified_app'], 'kind');
  const watchlistPublishers = entitiesFilter(entities, ['unified_publisher', 'publisher'], 'kind');
  const watchlistCompanies = entitiesFilter(entities, ['company'], 'kind');
  const params = {
    watchlist: {
      watchlist_apps_attributes: map(watchlistApps, (app) => ({
        ref_no: app.ref_no,
        store: appStore(app.store),
      })),
      watchlist_publishers_attributes: map(watchlistPublishers, (publisher) => ({
        ref_no: publisher.ref_no.toString(),
        store: appStore(publisher.store),
      })),
      watchlist_companies_attributes: map(watchlistCompanies, (company) => pick(company, 'ref_no')),
      ...watchlistParams,
    },
  };
  return params;
};
